import { EventRegistry } from './event_registry';

/**
 * A different type of event registry. It's meant to be a one shot use,
 * for example when things are initialised. After the first notifyListeners
 * is called, any clients who add a listener will get called back immediately
 */
export default class OneShotEventRegistry {
    _fired;
    _event;
    _firedWithArgs: any[];

    constructor() {
        this._fired = false;
        this._event = new EventRegistry();
    }

    /**
     * Add an event listener callback
     * @param listener A function
     * @returns {function()} A function that can be used to destroy the
     * event listener
     */
    addEventListener(listener) {
        if (!this._fired) {
            return this._event.addEventListener(listener);
        } else {
            // fire the listener immediately
            listener(...this._firedWithArgs);
        }
    }

    /**
     * Notify all listeners that the event has occurred.
     * Listeners will only be notified once.
     * Any arguments passed to notifyListeners() will also
     * be sent to the listeners.
     */
    async notifyListeners(...args): Promise<void> {
        if (!this._fired) {
            this._fired = true;
            // Save the last arguments in case any more listeners are attached
            this._firedWithArgs = args;
            await this._event.notifyListeners.apply(this._event, args);
            // We don't need to hold onto the listeners any more!
            this._event.destroyAllListeners();
        }
    }

    /**
     * Get the current fired state of the listener
     * @returns {boolean} Whether or not this has fired
     */
    get isFired() {
        return this._fired;
    }
}
